import {Field} from 'formik';

import {
    FormikNumberInput,
    PlatformFieldset
} from '@flexinet/ui-components';
import {Container} from "@mantine/core";
import {ProductFeaturesAutocomplete} from '../../product-features/inputs/ProductFeaturesAutocomplete';


export const FormComponent = () => {


    return (
        <Container>
            <PlatformFieldset legend={'Product Feature'}>
                <Field
                    name='productFeatureId'
                    label='Product Feature'
                    description='Please enter the product feature'
                    component={ProductFeaturesAutocomplete}
                    withAsterisk
                    my={'xl'}
                />

                <Field
                    name='position'
                    label='Position'
                    description='Please enter the position'
                    component={FormikNumberInput}
                    withAsterisk
                    my={'xl'}
                />


            </PlatformFieldset>
        </Container>
    );
};
